import { render, staticRenderFns } from "./KifuDetail.vue?vue&type=template&id=03d96249&scoped=true&"
import script from "./KifuDetail.vue?vue&type=script&lang=js&"
export * from "./KifuDetail.vue?vue&type=script&lang=js&"
import style0 from "./KifuDetail.vue?vue&type=style&index=0&id=03d96249&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d96249",
  null
  
)

export default component.exports